var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "btn",
    staticClass: "absolute-fill d-flex justify-center align-center"
  }, [_c('v-btn', _vm._b({
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    style: {
      transform: `scale(${_vm.scale})`
    },
    attrs: {
      "height": "56",
      "min-width": "56",
      "rel": "noopener noreferrer ugc nofollow",
      "target": "_blank",
      "dark": _vm.isDark,
      "elevation": _vm.isTransparent ? 0 : 6,
      "rounded": !_vm.isTransparent,
      "color": _vm.blob.btn.color || 'primary'
    },
    on: {
      "click": function ($event) {
        _vm.isInteractive && _vm.$emit('click');
      }
    }
  }, 'v-btn', _vm.isInteractive && _vm.blob.btn.url ? {
    href: _vm.blob.btn.url
  } : {}, false), [_vm.blob.btn.text ? _c('span', {
    class: {
      'mr-1': _vm.blob.btn.url
    },
    domProps: {
      "innerHTML": _vm._s(_vm.blob.btn.text)
    }
  }) : _vm._e(), !_vm.blob.btn.form ? _c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isTransparent,
      expression: "!isTransparent"
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.mdiOpenInNew)
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }